import * as React from 'react';
import { Link } from 'react-router-dom';
import styles from './Deluxe.css';
import DeluxeBannerImg from './DumpertDeluxeBanner.png';

export const DeluxeBanner = ({ number }) => {
  return (
    <Link 

      //to={Math.random() < 0.5 ? '/deluxe' : 'deluxe/maand'}
      to={number < 0.5 ? '/deluxe' : 'deluxe/maand'}
      className={styles.banner}>
      <img
        // eslint-disable-next-line
        src={DeluxeBannerImg}
        alt="Dumpert Deluxe"
      />
    </Link>
  );
};